import immutable from 'immutable'

import {
    ADD_TRAVELERS
} from '../planner/planner.action'


export default (state, action) => {
    switch (action.type) {
        case ADD_TRAVELERS:
    	return state.update((travelers) => {
                return travelers.push(action.travelers)
            })
        default:
            return state
    }
}
